import React, { Dispatch, SetStateAction } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { BasicButton } from './UI/BasicButton'
import { useAuth } from '../../auth'

export const DeleteConfirmationModal = ({
  showDeleteModal,
  setDeleteShowModal,
  headingMessage,
  description,
  handleDelete,
  deleteLoading,
  id,
  formik,
  companyFolderContentId,
  activeContentId
}: {
  showDeleteModal: boolean
  setDeleteShowModal: Dispatch<SetStateAction<boolean>>
  headingMessage: string
  description: string
  handleDelete?: any
  deleteLoading?: boolean
  id?: any
  formik?: any
  companyFolderContentId?: any
  activeContentId?: any
}) => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  return (
    <Modal
      show={showDeleteModal}
      onHide={() => setDeleteShowModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <h2>{formatMessage({ id: headingMessage })}</h2>
      </Modal.Header>
      <Modal.Body>
        <p>
          {formatMessage({
            id: description,
          })}
        </p>
      </Modal.Body>
      <Modal.Footer className='d-flex flex-md-row flex-column'>
        <BasicButton
          height='44px'
          border='none'
          // color='#F5F8FA'
          // textColor='#7E8299'
          padding='12px 16px'
          onClick={() => {
            setDeleteShowModal(false)
          }}
          buttonText='Cancel'
          customClass='bg-light text-muted custom-button-property order-md-1 order-2 w-100 w-md-auto'
        />

        {headingMessage === 'Remove Image' && (
          <BasicButton
            height='44px'
            border='1px solid #FF0000'
            color='#FF0000'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              handleDelete(formik)
            }}
            buttonText='Remove Image'
            minWidth={56}
            loading={deleteLoading}
            disabled={deleteLoading}
            customClass='custom-button-property order-md-2 order-1 w-100 w-md-auto'
          />
        )}

        {headingMessage !== 'Remove Image' && (
          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              if (activeContentId === companyFolderContentId) {
                handleDelete(id, +companyId!)
              }
              else {
                handleDelete(id)
              }
            }}
            buttonText='Confirm Delete'
            minWidth={56}
            loading={deleteLoading}
            disabled={deleteLoading}
            customClass='custom-button-property order-md-2 order-1 w-100 w-md-auto'
          />
        )}
      </Modal.Footer>
    </Modal>
  )
}
